import { ungzip } from 'pako';
export function ungzipStream(file) {
    return new ReadableStream({
        start(controller) {
            void file
                .arrayBuffer()
                .then((arrayBuffer) => ungzip(new Uint8Array(arrayBuffer)))
                .then((arrayBuffer) => {
                controller.enqueue(arrayBuffer);
                controller.close();
            });
        },
    });
}
//# sourceMappingURL=ungzipStream.browser.js.map